<template>
  <div class="sort-group">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SortGroup',
  props: {
    value: {
      required: true,
      type: [String, Number]
    },
    sort: {
      default: 'desc',
      validator(value) {
        return value === 'desc' || value === 'asc'
      },
      type: [String]
    }
  },

  data() {
    return {
      itemComponents: []
    }
  },

  watch: {
    value: {
      handler(newVal) {
        if (newVal && this.itemComponents.length) {
          this.setActive()
        }
      },
      immediate: true
    }
  },

  updated() {
    this.init()
  },

  methods: {
    init() {
      this.itemComponents = this.$children.filter(child => child.$options.name === 'SortItem')
      if (this.value) {
        this.setActive()
      }
    },

    setActive() {
      this.itemComponents.filter(child => {
        child.active = child.value === this.value
      })
    },

    select(value, showTriangles) {
      if (showTriangles) {
        if (value !== this.value) {
          this.$emit('update:sort', 'desc')
        } else {
          this.$emit('update:sort', this.sort === 'asc' ? 'desc' : 'asc')
        }
      }

      this.$emit('input', value)
      this.$emit('change', value)
    }
  },
}
</script>

<style lang="scss" scoped>
.sort-group {
  display: inline-block;
}
</style>
